import { StyleSheet } from 'react-native';

import Theme from 'Theme';

const baseStyles = {
    noDataText: {
        color: Theme.secondaryTextColor,
        textAlign: 'center',
        fontSize: Theme.primaryFontSize
    }
};

export default StyleSheet.create(baseStyles);
